import { validate } from 'email-validator';

export function validateEmail(
  email: string,
  { allowBlank }: { allowBlank: boolean } = { allowBlank: false },
): boolean {
  return validate(email) || (email.length === 0 && allowBlank);
}

export function isApiCryptOrMssEmail(email: string): boolean {
  const domain = email.split('@')[1];

  if (!domain) {
    return false;
  }

  return (
    domain.endsWith('mssante.fr') ||
    domain.endsWith('interop-mssante.apicrypt.org') ||
    domain.endsWith('apicrypt.org') ||
    domain.endsWith('apicrypt.fr')
  );
}
